export const selectStudentsListDataArray = state => state.students.studentsListArray || [];
export const selectStudentsListCount = state => state.students.count || [];
export const selectStudentsListPage = state => state.students.page || [];
export const selectStudentsHashList = state => state.students.studentsListHashList || [];
export const selectStudentsActiveFilters = state => state.students.activeFilters || {};
export const selectStudentsListIsLoading = state => state.students.studentsListIsLoading;
export const selectStudentItemDataIsLoading = state => state.students.studentItemDataIsLoading;
export const selectCurrentStudentData = state => state.students.currentStudentData || {};
export const selectStudentsListActiveCount = state => state.students.activeCount || [];
export const selectSafeguardingBehaviours = state => state.studentList?.safeguardingBehaviours || [];

